import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Settings } from "lucide-react";
import { api } from "../lib/api";
import { Badge } from "./ui/badge";
import { Skeleton } from "./ui/skeleton";

export function AppHeader() {
  const account = useQuery({
    queryKey: ["account"],
    queryFn: api.getAccount,
  });

  if (account.isLoading) {
    return (
      <header className="flex items-center justify-between border-b px-4 py-2">
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-5 w-24" />
      </header>
    );
  }

  if (!account.data) return null;

  const d = account.data;
  const dialogPercent =
    d.dialogsLimit > 0
      ? Math.round((d.dialogsUsed / d.dialogsLimit) * 100)
      : 0;
  const isCritical = dialogPercent >= 95;
  const isWarning = dialogPercent >= 80;

  return (
    <header className="flex items-center justify-between border-b px-4 py-2">
      <span className="text-sm font-medium">AI CRM</span>
      <div className="flex items-center gap-1.5">
        <Badge variant="outline" className="text-xs">{d.plan}</Badge>
        <Badge
          variant={isCritical ? "destructive" : isWarning ? "secondary" : "outline"}
          className="text-xs"
        >
          {d.dialogsUsed}/{d.dialogsLimit}
        </Badge>
        <Link
          to="/settings/wazzup"
          aria-label="Настройки"
          className="ml-1 text-muted-foreground hover:text-foreground"
        >
          <Settings className="h-4 w-4" />
        </Link>
      </div>
    </header>
  );
}
